/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'filePdf': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M826.6 959.1H197c-49.5 0-89.9-36.6-89.9-81.4V145.3c0-44.8 40.5-81.4 89.9-81.4h494.7l224.8 223.8v590.1c0 44.7-40.4 81.3-89.9 81.3zM669.2 104.6h-22.5V308h224.8L669.2 104.6zm202.4 244.1H646.7c-24.7 0-45-18.3-45-40.7V104.6H197c-24.7 0-45 18.3-45 40.7v732.5c0 22.4 20.2 40.7 45 40.7h629.6c24.7 0 45-18.3 45-40.7V348.7zM653.9 649.9h60.5v27.6h-60.5v58.9h-38.1V589.1h100.8v27.6h-62.7v33.2zm-100.7 70c-17.9 12.9-42.5 18.4-76.1 18.4-20.2 0-33.6 0-42.5-1.8V592.8c13.4-1.8 33.6-3.7 51.5-3.7 31.4 0 51.5 5.5 64.9 16.6 17.9 11 29.1 29.5 29.1 55.2-.1 27.7-11.3 47.9-26.9 59zm-62.7-105c-9 0-15.7 1.8-17.9 1.8v95.8H486c33.6 0 56-16.6 56-51.6 0-29.4-20.2-46-51.5-46zm-85.1 55.2c-13.4 9.2-31.3 14.7-53.7 14.7h-13.4v51.6h-38.1V592.8c11.2-1.8 29.1-3.7 51.5-3.7 24.6 0 40.3 3.7 51.5 12.9 11.2 7.4 17.9 18.4 17.9 33.1-.1 14.8-6.8 27.7-15.7 35zm-51.6-55.2c-6.7 0-13.4 1.8-15.7 1.8v42.4h13.4c20.2 0 31.4-9.2 31.4-22.1.1-14.7-11.1-22.1-29.1-22.1z" _fill="#FFF"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/filePdf.js